import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';

export const Dot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  background-color: ${({ color }) => color || 'var(--color-background-dark)'};
`;

type ColorLabelProps = PropsWithChildren<{ color?: string }>;

export default function ColorLabel({ color, children }: ColorLabelProps) {
  return (
    <>
      <Dot color={color} />
      {children}
    </>
  );
}
